<template>
  <span class="error-price-catalog">
    <span class="error-price-catalog__title">
      <span class="error-price-catalog__title-err">N/A</span>
      {{ currencySymbol }}
    </span>
    <div class="error-price-catalog__info-wrap">
      <div
        ref="infoErrorPrice"
        class="error-price-catalog__info"
        :style="{
          left: `${delta}px`
        }"
      >
        <span
          ref="infoTriangleErrorPrice"
          class="error-price-catalog__info-triangle"
          :style="{
            left: `${leftTriangle - delta}px`
          }"
        ></span>
        <icon name="warning" class="item__warning-icon" />
        <span v-html="$t('event.catalog.modal.errorPriceService')"></span>
      </div>
    </div>
  </span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ErrorPriceCatalog",

  data() {
    return {
      delta: 0,
      leftTriangle: 23
    };
  },

  computed: {
    ...mapGetters("eventCatalog", ["currencySymbol"])
  },

  mounted() {
    this.setPositionInfo();
    window.addEventListener("resize", this.setPositionInfo);
  },

  methods: {
    setPositionInfo() {
      if (this.$refs.infoErrorPrice) {
        const params = this.$refs.infoErrorPrice.getBoundingClientRect();
        const documentWidth = document.querySelector("body").offsetWidth;
        const result =
          documentWidth - (params.left - this.delta + params.width) - 16;

        this.delta = result < 0 ? Math.floor(result) : 0;
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.setPositionInfo);
  }
};
</script>

<style scoped lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.error-price-catalog {
  position: relative;

  &__title {
    white-space: nowrap;
    cursor: pointer;

    &-err {
      color: #f6931d;
    }
    &:hover ~ .error-price-catalog__info-wrap {
      z-index: 0;
      opacity: 1;
      visibility: visible;
    }
  }
  &__info {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: flex-start;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 12px 15px;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: #f6931d;
    border-radius: 2px;
    background: #faebe8;

    &-wrap {
      display: inline-block;
      position: absolute;
      z-index: -1;
      opacity: 0;
      visibility: hidden;
      bottom: calc(100% + 12px);
      left: -15px;
      width: 200px;
    }
    &-triangle {
      display: block;
      position: absolute;
      bottom: -6px;
      left: 23px;
      width: 12px;
      height: 12px;
      border-radius: 2px;
      background-color: #faebe8;
      transform: rotate(-45deg);
    }
    .svg-icon {
      display: inline-block;
      vertical-align: middle;
      min-width: 16px;
      width: 16px;
      height: 16px;
      margin-top: 2px;
      margin-right: 12px;
      fill: #f6931d;
    }
    &-text {
      flex: 1;
    }
  }
}
</style>
